<template>
  <v-container>

    <v-container v-if="fax.number">
      <div v-if="showForm">
        <v-form>
          <v-card v-if="fax.requires_password=='Y'" shaped>
            <v-card-title>Passcode required</v-card-title>
            <v-card-subtitle>This fax line requires a passcode to submit PDF files to.</v-card-subtitle>
            <v-card-text>
            <v-text-field
              v-model="password"
              label="Passcode"
              v-bind:error="passwordError"
            ></v-text-field>
            </v-card-text>
          </v-card>
          <v-dialog v-model="showIncorrectPassword" persistent max-width="350">
            <v-card>
              <v-card-title class="headline">Incorrect passcode</v-card-title>
              <v-card-text>The passcode you provided does not match. Unable to submit PDF file.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" text v-on:click="showIncorrectPassword = false">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <br>
          <v-card
            :loading="uploading"
          >
            <v-card-title>Send PDF to {{faxNumber}}</v-card-title>
            <v-card-text v-if="uploading">Sending PDF to {{faxNumber}}.</v-card-text>
            <v-card-text v-if="uploading">This could take a while, depending on the size of the PDF.</v-card-text>
            <v-card-text v-if="!uploading">
              <v-text-field
                v-model="from"
                label="From"
                required
                v-bind:disabled="uploading"
              ></v-text-field>

              <v-text-field
                v-model="note"
                label="Notes"
                required
                v-bind:disabled="uploading"
              ></v-text-field>

              <v-file-input
                accept=".pdf"
                prepend-icon="mdi-paperclip"
                label="File upload"
                v-model="file"
                v-bind:disabled="uploading"
              ></v-file-input>
              
                <v-btn
                color="info"                  
                v-on:click="uploadFile"
                v-bind:disabled="uploading"
              >
                Upload
              </v-btn>
              &nbsp;
              <v-btn
                color=""                  
                v-on:click="goHome"
                v-bind:disabled="uploading"
              >
                Cancel
              </v-btn>
            </v-card-text>
          </v-card>
        </v-form>
      </div>
      <div v-if="showFormUploaded">
        <v-card shaped>
          <v-card-title>Your file has been submitted</v-card-title>
          <v-card-text>Print this for your records</v-card-text>
          <v-card-text>
            Filename: {{originalFileName}}<br>
            Pages Received: {{pages}}<br>
            Received: {{receivedDate}}<br>
            From: {{receivedFrom}}<br><br>
            Checksum: {{checksum256}}<br>
            <br>
            The checksum is a digital signature that can confirm that two files are identical. The above checksum was created with a SHA-256 cryptographic algorythm.
          </v-card-text>
        </v-card>
      </div>
    </v-container>
    
  </v-container>
</template>

<script>

  import gql from 'graphql-tag';
  
  const getFaxQry = gql`
    query faxPublicQry($number: String) {
      faxPublic(number: $number) {
        number
        requires_password
      }
    }
  `;

  export default {
    name: 'HelloWorld',
    props: {
      faxNumber: { 
        required: true,
      },
    },
    data: () => ({
      fax: {},
      password: null,
      passwordError: false,
      showIncorrectPassword: false,
      file: null,
      from: null,
      note: null,
      showForm: true,
      showFormUploaded: false,
      originalFileName: null,
      checksum256: null,
      receivedDate: null,
      pages: null,
      receivedFrom: null,
      uploading: false,
    }),
    methods: {
      getFax: function() {
        let self = this;
        let variables = {
          number: this.faxNumber.replace(/\-/g,''),
        };
        this.$global.apolloClient.query({query: getFaxQry, variables, fetchPolicy: 'network-only'})
        .then( function(result) {
          if (result.data.faxPublic) {
            self.fax = result.data.faxPublic;
          }
        });     
      },
      goHome: function() {
        this.$router.push('/');
      },
      uploadFile: function() {
        let self =this;
        self.uploading = true;
        let data = new FormData();
        data.append('dfs234324lkjaf33SSdfhdwwmw833wlq', self.file);
        data.append('original_filename', self.file.name);
        data.append('number', self.fax.number);
        data.append('password', self.password);
        data.append('from', self.from);
        data.append('note', self.note);
        data.append('contentType', self.file.type);
        data.append('size', self.file.size);

        fetch(`${self.$global.apiEndPoint}/fax/upload`, {
            headers: {authorization: self.$store.getters.authorizationToken},
            method: 'POST',
            body: data,
        }).then(function(response) {
          return response.json().then(result => {
              // the status was ok and there is a json body
              self.uploading = false;
              if (result.error) {
                if (result.error == 'Incorrect Password') {
                  self.passwordError = true;
                  self.showIncorrectPassword = true;
                }
              } else {
                self.passwordError = false;
                self.showForm = false;
                self.showFormUploaded = true;
                self.checksum256 = result.checksum256;
                self.originalFileName = result.filename_original;
                self.receivedDate = new Date(result.received_date);
                self.receivedFrom = result.callerid_name;
                self.pages = result.fax_pages_received;
              }

          });
        });

      },
    },
    beforeMount() {
      this.getFax();
    },
    watch: {

    },
    filters: {

    },
  }
</script>
